import { render, staticRenderFns } from "./DPHZ.vue?vue&type=template&id=fd8bec2a&scoped=true"
import script from "./DPHZ.vue?vue&type=script&lang=js"
export * from "./DPHZ.vue?vue&type=script&lang=js"
import style0 from "./DPHZ.vue?vue&type=style&index=0&id=fd8bec2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8bec2a",
  null
  
)

export default component.exports